// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__T_9Pn"};